<template>
  <div>
    <div class="section-results">
      <p style="font-size: 12px; color: black">
        Section{{ " "
        }}<span
          :style="
            window.width < 480
              ? 'font-size:12px;color:rgb(133, 183, 248)'
              : 'font-size:16px;color:rgb(133, 183, 248)'
          "
          >{{ entitled }}</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SectionTitle',
  props: {
    index: {
      type: Number,
      required: false
    },
    entitled_all: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: true
    },
    questionId: {
      required: false
    },
    window: {
      required: true
    }
  },
  data () {
    return {
      entitled: ''
    }
  },
  computed: {
    ...mapGetters([
      'sections',
      'configure_questions_sondage_name',
      'sondage_vue_resultats'
    ])
  },
  watch: {
    sections () {
      this.findTitleSection()
    }
  },
  mounted () {
    this.findTitleSection()
  },
  methods: {
    findTitleSection () {
      switch (this.type) {
        case 'slider':
          this.sections.map(x => {
            x.questions.map(y => {
              if (JSON.stringify(y.id) === this.questionId) {
                this.entitled = x.entitled
              }
            })
          })
          break
        case 'all':
          this.entitled = this.entitled_all
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/section/SectionTitle.vue